import React, { useContext, useMemo, useRef, useState } from 'react';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getBookRecomentation } from '../../NecttosComp/APICaller/ApiServices';
import SearchableImput from '../../NecttosComp/Input/SearchableImput';
import moment from 'moment';
import { Body, closeAnimation, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import Instruction from '../../Documentation/Instruction';

export const BookRecomentation = ({ onClose }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const { data = [], refetch } = useQuery('getBookRecomentation', getBookRecomentation(collegeId));
	const [isLoading, setIsLoading] = useState(false);
	const [state, setState] = useState({});
	const [showForm, setShowForm] = useState(false);

	const manageHolidays = async () => {
		try {
			setIsLoading(true);
			if (!state.nameOfBook) throw new Error('Book Name is Empty');
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/action/postBookRecomentation', {
				collegeId,
				...state,
			});
			if (resp.data.statusCode !== 200) throw new Error(resp.data.message || 'API Error');
			setState({});
			refetch();
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	};

	const getUserList = async ({ queryKey }) => {
		const [_, { type, collegeId, classId }] = queryKey;
		const instance = await getAxiosTokenInstance();
		const resp = await instance.get(`college/users/get?collegeId=${collegeId}${type === 'all' ? '' : `&type=${type}`}${classId ? `&classId=${classId}` : ''}`);
		if (resp.data.statusCode === 400) throw new Error(resp.data.message || 'API Error');
		return resp.data;
	};

	const { data: userList } = useQuery([`userListstudent`, { type: 'student', classId: '', collegeId }], getUserList);
	const [searchTerm, setSearchTerm] = useState('');

	const filteredData = useMemo(() => {
		if (!searchTerm) return data;
		const search = searchTerm.toLowerCase();
		return data.filter((item) => {
			return (
				String(item?.nameOfBook || '')
					.toLowerCase()
					.includes(search) ||
				String(item?.nameOfAuthor || '')
					.toLowerCase()
					.includes(search) ||
				String(item?.yearOfPublication || '')
					.toLowerCase()
					.includes(search) ||
				String(item?.nameOfPublisher || '')
					.toLowerCase()
					.includes(search) ||
				String(item?.userName || '')
					.toLowerCase()
					.includes(search)
			);
		});
	}, [data, searchTerm]);

	return (
		<Main width='100%' height='100%' title='Book Recommendation Management'>
			<Header>
				<div className='flex'>
					<Input2 type='text' state={{ searchTerm }} setState={(val) => setSearchTerm(val?.searchTerm || '')} returnKey='searchTerm' fieldName='Search By All' className='w-[400px]' inputClassName='text-sm' inputWidth='w-full' />
				</div>
				<div className='flex'>
					<Button type='save' onClick={() => setShowForm(true)}>
						Add New
					</Button>
					<Button type='fetch' onClick={refetch}>
						Reload
					</Button>
					<Button type='print' tableRef={componentRef.current}>
						Print
					</Button>
					<Instruction keyId={'bookRecomentation'} />
					{!isLoading && (
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					)}
				</div>
			</Header>

			<Body>
				<div ref={componentRef} className='printable bg-gray-100 dark:bg-neutral-800 print:bg-white print:text-black'>
					<div className='flex flex-col items-center justify-center mb-4'>
						<img src={selectedCollege?.logo} className='w-[55px] h-[55px] md:w-[10%] md:h-auto object-contain m-2' />
						<h5 className='text-2xl font-bold text-center dark:text-slate-100'>Book Recommendation Management</h5>
					</div>

					<Table width='100%' innerWidth={['4%', '20%', '15%', '10%', '15%', '18%', '13%', '5%']}>
						<Thead>
							<Tr>
								<Th position={0}>Sn</Th>
								<Th position={1}>Book Name</Th>
								<Th position={2}>Subject</Th>
								<Th position={3}>Year</Th>
								<Th position={4}>Publisher</Th>
								<Th position={5}>Recommended By</Th>
								<Th position={6}>Recommended On</Th>
								<Th position={7}></Th>
							</Tr>
						</Thead>
						<Tbody height='65vh'>
							{filteredData?.map((item, i) => (
								<Tr key={i} index={i}>
									<Td index={i} position={0}>
										{i + 1}
									</Td>
									<Td index={i} position={1}>
										{item?.nameOfBook || '-'}
									</Td>
									<Td index={i} position={2}>
										{item?.nameOfAuthor || '-'}
									</Td>
									<Td index={i} position={3}>
										{item?.yearOfPublication || '-'}
									</Td>
									<Td index={i} position={4}>
										{item?.nameOfPublisher || '-'}
									</Td>
									<Td index={i} position={5}>
										{item?.userName || '-'}
									</Td>
									<Td index={i} position={6}>
										{item?.createdOn ? moment(item.createdOn).format('DD MMM YYYY') : '-'}
									</Td>
									<Td index={i} position={7}>
										<div className='no-print print:hidden'>
											<Button
												type='edit'
												onClick={() => {
													setState({
														nameOfBook: item?.nameOfBook || '',
														nameOfAuthor: item?.nameOfAuthor || '',
														yearOfPublication: item?.yearOfPublication || '',
														nameOfPublisher: item?.nameOfPublisher || '',
														userId: item?.recomendedBy || '',
														_id: item?._id || '',
													});
													setShowForm(true);
												}}>
												Edit
											</Button>
										</div>
									</Td>
								</Tr>
							))}
						</Tbody>
					</Table>

					<div className='m-4 text-base text-right text-black dark:text-white'>Seal & Signature {moment(new Date()).format('DD MMM YYYY hh:mm A')}</div>
				</div>
			</Body>

			{showForm && (
				<div className='fixed inset-0 z-[9999] bg-black/40 backdrop-blur-sm flex items-center justify-center'>
					<Main width='45vw' height='80vh' title={state._id ? 'Edit Book Details' : 'Add New Book'}>
						<Header>
							<div className='flex'></div>
							<div className='flex'>
								<Button
									type='close'
									onClick={() => {
										closeAnimation();
										setTimeout(() => setShowForm(false), 500);
									}}>
									Close
								</Button>
							</div>
						</Header>

						<Body>
							<div className='p-4 space-y-4 text-sm text-gray-800 dark:text-gray-100'>
								<div className='grid grid-cols-1 gap-4'>
									<SearchableImput keyData='nameOfBook' titleData={<label className='text-lg text-gray-700 dark:text-gray-300'> Title of Book</label>} collection='books' stateData={state} setStateData={setState} />
									<SearchableImput keyData='nameOfAuthor' titleData={<label className='text-lg text-gray-700 dark:text-gray-300'> Subject</label>} collection='books' stateData={state} setStateData={setState} />
									<SearchableImput keyData='nameOfPublisher' titleData={<label className='text-lg text-gray-700 dark:text-gray-300'> Publisher Name</label>} collection='books' stateData={state} setStateData={setState} />
									<Input2 type='number' fieldName='Year of Publication' returnKey='yearOfPublication' state={state} setState={setState} className='w-full' />
									<Input2
										type='drop'
										state={state}
										returnKey='userId'
										fieldName=' Recommended By *'
										optionDisplay='name'
										optionKey='_id'
										didntShowKey
										options={userList?.list?.map((item) => ({
											_id: item._id,
											name: `${item.admisionNo} - ${item.name}`,
										}))}
										setState={(newState) => {
											const selectedUser = userList.list.find((x) => x._id === newState?.userId);
											setState({
												...state,
												name: selectedUser?.name || '',
												userId: selectedUser?._id || '',
											});
										}}
										required
										className='w-full'
										inputClassName='text-sm'
										inputWidth='w-full'
									/>
								</div>

								<div className='flex justify-end gap-4 pt-4 border-t border-gray-200 dark:border-gray-700'>
									<Button type='close' onClick={() => setState({})}>
										Reset Form
									</Button>
									<Button type='save' onClick={manageHolidays}>
										Submit
									</Button>
								</div>
							</div>
						</Body>
					</Main>
				</div>
			)}
		</Main>
	);
};
